import type { AtomModel, Font } from '@/app/editor/iframe/atom/Atom.model';
import { getCommonButtonFormControlSettings } from '@/app/utils/commonBtnSettings';
import { GpChildProduct } from '@/app/editor/iframe/atom/module/GpChildProduct';

/**
 * (P) View More Atom Module
 */
export class GpViewMore extends GpChildProduct {
  /**
   * Return Atom data
   * @override Atom.getDataAtom
   * @returns object watch
   */
  getDataAtom(): AtomModel {
    const data: AtomModel = {
      type: this.getType(),
      id: this.getId(),
      nodeId: this.getIdNode(),
      name: '(P) View More',
      slug: 'p-view-more',
      groupName: 'Product',
      settings: this.getSettings(),
      data: this.getDataChilds(),
      html: this.getTemplate(),
      class: '.gf_view-more',
      style: this.getStyle(),
      script: this.getScript(),
      libs: this.getLibs(),
      fonts: [] as Font[],
      version: 1,
      formControlSettings: getCommonButtonFormControlSettings('.gf_view-more', { isDynamicModule: true }),
    };
    return data;
  }

  /**
   * @override Atom.getTargetClass
   */
  getTargetClass(): string {
    return '.gf_view-more';
  }
}
